import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import ContentBasicInformation from './NewInfoForms/ContentBasicInformation';
import ContentHeader from './NewInfoForms/ContentHeader';
import ContentUpload from './NewInfoForms/ContentUpload';
import axios from 'axios';
import { createContent } from 'lib/apiService';
import ContentType from './NewInfoForms/ContentType';
import ContentDetails from './NewInfoForms/ContentDetails';
import FileUpload from './NewInfoForms/FileUpload';

const schema = yup
  .object({
    title: yup.string().required('Энэ талбарыг оруулна уу!'),
    description: yup.string().required('Энэ талбарыг оруулна уу!'),
    contentType: yup.string().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const ContentAdd = () => {
  const navigage = useNavigate();
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const [loading, setLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const { handleSubmit, reset } = methods;
  const [files, setFiles] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  const imageUploader = async image => {
    setLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setImageUrls(prevUrls => [
      ...prevUrls,
      {
        url: data.secure_url,
        public_id: data.public_id,
        name: data.display_name
      }
    ]);

    setLoading(false);
  };

  const FileUploader = async image => {
    setFileLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setUploadFiles(prevUrls => [
      ...prevUrls,
      {
        url: data.secure_url,
        public_id: data.public_id,
        name: data.display_name
      }
    ]);

    setFileLoading(false);
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      data.image = imageUrls[0];
      data.file = uploadFiles[0];
      createContent(data)
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай үүсгэгдлээ`, {
              theme: 'colored'
            });

            reset();
            navigage(`/content/content-update/${result?.data?.data?._id}`);
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
    }
  };

  const handleRemove = path => {
    let removeItem = '';
    imageUrls.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setFiles(files.filter(file => file.path !== path));
    const updatedImageUrls = imageUrls.filter(
      image => image.bucketname !== path
    );
    setImageUrls(updatedImageUrls);
    if (removeItem) {
      axios
        .post(`https://admin.gegeensoft.live/api/v1/images/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  const handleFileRemove = path => {
    let removeItem = '';
    uploadFiles.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setPdfFiles(pdfFiles.filter(file => file.path !== path));
    const updatedPdfUrls = uploadFiles.filter(
      image => image.bucketname !== path
    );
    setUploadFiles(updatedPdfUrls);
    if (removeItem) {
      axios
        .post(`https://admin.gegeensoft.live/api/v1/images/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <ContentHeader />
          </Col>
          <Col lg={8}>
            <ContentBasicInformation />
            <ContentUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <FileUpload
              setFiles={setPdfFiles}
              files={pdfFiles}
              fileUploader={FileUploader}
              handleRemove={handleFileRemove}
              loading={fileLoading}
            />
            <ContentDetails />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ContentType />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default ContentAdd;
